import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";

const saleTicketEstimate = (payload) =>
  instance.post(apiUrls.SALE_TICKET_ESTIMATE, payload);

const saleTicket = (payload) =>
  instance.post(apiUrls.SALE_TICKET, payload);

const getSaleTicket = (ticketId) =>
  instance.get(`${apiUrls.SALE_TICKET}/${ticketId}`);

export {
  saleTicketEstimate,
  saleTicket,
  getSaleTicket
};
